import { render } from "./SidebarItemLink.vue?vue&type=template&id=9cfbc83c"
import script from "./SidebarItemLink.vue?vue&type=script&lang=ts"
export * from "./SidebarItemLink.vue?vue&type=script&lang=ts"
script.render = render

export default script